import { defineStore } from "pinia";

import { useEntityStore } from "@/shared";

import { addExpense } from "../api/addExpense";
import { deleteExpense } from "../api/deleteExpense";
import { deleteExpenses } from "../api/deleteExpenses";
import { editExpense } from "../api/editExpense";
import { exportExpenses } from "../api/exportExpenses";
import { getExpense } from "../api/getExpense";
import { getExpenses } from "../api/getExpenses";

export const useExpensesStore = defineStore("expenses", () => {
    const {
        isManyLoading,
        manyError,
        isOneLoading,
        listData,
        singleData,
        meta,
        permissions,
        addOne,
        deleteOne,
        deleteMany,
        editOne,
        fetchMany,
        getOne,
        exportMany,
        setManyLoading,
    } = useEntityStore({
        addEntity: addExpense,
        getEntity: getExpense,
        getEntities: getExpenses,
        deleteEntity: deleteExpense,
        deleteEntities: deleteExpenses,
        editEntity: editExpense,
        exportEntities: exportExpenses,
    });

    return {
        listData,
        singleData,
        isManyLoading,
        manyError,
        isOneLoading,
        meta,
        permissions,
        fetchMany,
        deleteOne,
        deleteMany,
        getOne,
        editOne,
        addOne,
        exportMany,
        setManyLoading,
    };
});
